import React from "react";
import Slider from "react-slick"; // Import react-slick slider
import "slick-carousel/slick/slick.css"; // Import slick CSS
import "slick-carousel/slick/slick-theme.css"; // Import slick theme
import styles from '../../css/Part11.module.css'; // Import your CSS

function OurDepartment() {
  const teams = [
    {
      name: "IT Team",
      imgSrc: "/images/team/Our IT.jpg", 
    },
    {
      name: "BD & Marketing Team",
      imgSrc: "/images/team/Our BD and Marketing.jpg", 
    },
    {
      name: "Finance & HR Team",
      imgSrc: "/images/team/Our Team-03.jpg", 
    },
    {
      name: "Operation Team",
      imgSrc: "/images/team/Our Operation.png", 
    },
  ];

  // Settings for the react-slick slider
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  return (
    <section className={styles.departmentcontainer}> 
      {/* Desktop view */}
      <div className={styles.teamcontainer}>
        {teams.map((team, index) => (
          <div key={index} className={styles.teamcard}>
            <img src={team.imgSrc} alt={team.name} className={styles.teamimage} />
            <h3>{team.name}</h3>
          </div>
        ))}
      </div>

      {/* Mobile view - Carousel */}
      <div className={styles.mobilecarousel}>
        <Slider {...sliderSettings}>
          {teams.map((team, index) => (
            <div key={index} className={styles.teamcard}>
              <img src={team.imgSrc} alt={team.name} className={styles.teamimage} />
              <h3>{team.name}</h3>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
}

export default OurDepartment;
